import React, { HTMLProps } from 'react';
import { KibChewyIcon } from '@chewy/kib-icons-react';
import './logo.scss';
import classNames from 'classnames';

const Icon = () => (
  <div className="starter_guide_logo__icon">
    <KibChewyIcon className="starter_guide_logo__svg" aria-hidden="true" focusable="false" />
  </div>
);

interface LogoProps extends HTMLProps<HTMLHeadingElement> {
  isMainLogo?: boolean;
  title: string;
}

const Logo = ({ className, title, isMainLogo = false }: LogoProps) =>
  !isMainLogo ? (
    <h2 className={classNames('kib-typography-title2 starter_guide_logo', className)}>
      <Icon />
      {title}
    </h2>
  ) : (
    <h1 className={classNames('kib-typography-title2 starter_guide_logo', className)}>
      <Icon />
      {title}
    </h1>
  );

export default Logo;
